function pauseUgcVideos(videos, playingVideo) {
  for (const video of videos) {
    if (video !== playingVideo) {
      video.pause();
    }
  }
}

function toggleUgcVideo(video, videos) {
  if (!video.paused) {
    video.pause();
    return;
  }

  pauseUgcVideos(videos, video);
  video.muted = false;
  video.play();
}

function updateUgcCardProgress(card, video) {
  if (!video.duration) {
    return;
  }

  const progress = video.currentTime / video.duration;
  card.style.setProperty('--ugc-progress', progress);
}

function initUgcCarousel(section) {
  const carousel = section.querySelector('.lp-ugc-videos__carousel');
  const videos = Array.from(section.querySelectorAll('video'));

  new Swiper(carousel, {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 600,
    navigation: {
      prevEl: section.querySelector('.lp-ugc-videos__arrow--prev'),
      nextEl: section.querySelector('.lp-ugc-videos__arrow--next'),
    },
  });

  const cards = section.querySelectorAll('.lp-ugc-videos__card');

  for (const card of cards) {
    const video = card.querySelector('video.lp-ugc-videos__video');
    const playButton = card.querySelector('.lp-ugc-videos__play');

    if (!video) {
      continue;
    }

    playButton.addEventListener('click', () => toggleUgcVideo(video, videos));
    video.addEventListener('click', () => toggleUgcVideo(video, videos));
    video.addEventListener('play', () => card.classList.add('is-playing'));
    video.addEventListener('pause', () => card.classList.remove('is-playing'));
    video.addEventListener('timeupdate', () => updateUgcCardProgress(card, video));
  }
}

function initUgcStories(section) {
  const carousel = section.querySelector('.lp-ugc-videos__carousel');
  const cards = Array.from(section.querySelectorAll('.lp-ugc-videos__card'));
  const segments = Array.from(section.querySelectorAll('.lp-ugc-videos__segment'));
  const imageDuration = Number(section.dataset.imageDuration) * 1000;
  const storyState = { activeIndex: 0, isVisible: false, imageTimer: null, imageElapsed: 0, imageTickAt: 0 };

  function activeVideo() {
    return cards[storyState.activeIndex].querySelector('video.lp-ugc-videos__video');
  }

  function setProgress(ratio) {
    const activeSegment = segments[storyState.activeIndex];

    if (!activeSegment) {
      return;
    }

    activeSegment.querySelector('.lp-ugc-videos__segment-fill').style.width = `${ratio * 100}%`;
  }

  function markSegments(index) {
    segments.forEach((segment, segmentIndex) => segment.classList.toggle('is-done', segmentIndex < index));
    segments.forEach((segment, segmentIndex) => segment.classList.toggle('is-active', segmentIndex === index));

    for (const fill of section.querySelectorAll('.lp-ugc-videos__segment-fill')) {
      fill.style.width = '';
    }
  }

  function stopImageTimer() {
    cancelAnimationFrame(storyState.imageTimer);
    storyState.imageTimer = null;
  }

  function tickImageTimer(now) {
    storyState.imageElapsed += now - storyState.imageTickAt;
    storyState.imageTickAt = now;

    const ratio = Math.min(storyState.imageElapsed / imageDuration, 1);
    setProgress(ratio);

    if (ratio >= 1) {
      swiper.slideNext();
      return;
    }

    storyState.imageTimer = requestAnimationFrame(tickImageTimer);
  }

  function startImageTimer() {
    if (!imageDuration || storyState.imageTimer || !storyState.isVisible) {
      return;
    }

    storyState.imageTickAt = performance.now();
    storyState.imageTimer = requestAnimationFrame(tickImageTimer);
  }

  function playActiveStory() {
    const video = activeVideo();

    if (!video) {
      startImageTimer();
      return;
    }

    if (!storyState.isVisible || !video.paused) {
      return;
    }

    video.muted = true;
    video.play().catch(() => {});
  }

  function pauseActiveStory() {
    stopImageTimer();

    const video = activeVideo();

    if (video) {
      video.pause();
    }
  }

  function showStory(index) {
    pauseActiveStory();

    const previousVideo = activeVideo();

    if (previousVideo) {
      previousVideo.currentTime = 0;
    }

    storyState.activeIndex = index;
    storyState.imageElapsed = 0;
    markSegments(index);
    playActiveStory();
  }

  const swiper = new Swiper(carousel, {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    speed: 250,
    rewind: true,
  });

  swiper.on('slideChange', () => showStory(swiper.activeIndex));

  for (const card of cards) {
    const media = card.querySelector('.lp-ugc-videos__video');
    const video = card.querySelector('video.lp-ugc-videos__video');

    if (media) {
      media.addEventListener('click', () => swiper.slideNext());
    }

    if (!video) {
      continue;
    }

    video.addEventListener('play', () => card.classList.add('is-playing'));
    video.addEventListener('pause', () => card.classList.remove('is-playing'));
    video.addEventListener('ended', () => swiper.slideNext());
    video.addEventListener('timeupdate', () => {
      if (video.duration) {
        setProgress(video.currentTime / video.duration);
      }
    });
  }

  function playWhenVisible(entries) {
    storyState.isVisible = entries.some((entry) => entry.isIntersecting);

    if (storyState.isVisible) {
      playActiveStory();
      return;
    }

    pauseActiveStory();
  }

  new IntersectionObserver(playWhenVisible, { threshold: 0.5 }).observe(carousel);
}

function initLPUgcVideos(sectionId = '') {
  const section = document.getElementById(sectionId);

  if (!section) {
    return;
  }

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  if (isMobile) {
    initUgcStories(section);
    return;
  }

  initUgcCarousel(section);
}
